import React from 'react'

const S = {
  wrap: { maxWidth: 800, margin: '0 auto', padding: '3rem 1.5rem 5rem', fontFamily: "'DM Sans', sans-serif", color: '#1a1a1a', lineHeight: 1.8 },
  h1: { fontSize: '2rem', fontWeight: 700, marginBottom: '.5rem', color: '#1a3c2b' },
  sub: { color: '#666', fontSize: '.9rem', marginBottom: '2.5rem' },
  h2: { fontSize: '1.15rem', fontWeight: 700, marginTop: '2rem', marginBottom: '.5rem', color: '#1a3c2b' },
  p: { marginBottom: '1rem', color: '#333' },
  ul: { paddingLeft: '1.5rem', marginBottom: '1rem', color: '#333' },
  li: { marginBottom: '.4rem' },
}

export default function PrivacyPolicy() {
  return (
    <div style={S.wrap}>
      <h1 style={S.h1}>Privacy Policy</h1>
      <p style={S.sub}>Last updated: June 2026 &nbsp;·&nbsp; Revive Skin &amp; Hair Experts</p>

      <h2 style={S.h2}>1. Information We Collect</h2>
      <p style={S.p}>We collect the following information when you use Revive:</p>
      <ul style={S.ul}>
        <li style={S.li}><strong>Personal details</strong> — name, phone number, email address</li>
        <li style={S.li}><strong>Health information</strong> — skin concerns, medical history, diagnoses, prescriptions</li>
        <li style={S.li}><strong>Photos</strong> — skin scan images and progress photos you upload</li>
        <li style={S.li}><strong>Payment information</strong> — processed securely by Razorpay (we do not store card details)</li>
        <li style={S.li}><strong>Usage data</strong> — pages visited, appointment history, product orders</li>
      </ul>

      <h2 style={S.h2}>2. How We Use Your Information</h2>
      <ul style={S.ul}>
        <li style={S.li}>To provide dermatology consultations and treatment plans</li>
        <li style={S.li}>To send appointment confirmations and reminders via WhatsApp</li>
        <li style={S.li}>To send OTP login codes via WhatsApp</li>
        <li style={S.li}>To process product orders and payments</li>
        <li style={S.li}>To analyse skin conditions using our AI skin scanner</li>
        <li style={S.li}>To send medication reminders (only if you opt in)</li>
      </ul>

      <h2 style={S.h2}>3. Third-Party Services</h2>
      <p style={S.p}>We use the following trusted third-party services:</p>
      <ul style={S.ul}>
        <li style={S.li}><strong>Meta WhatsApp Business API</strong> — for OTP and appointment messages</li>
        <li style={S.li}><strong>Razorpay</strong> — for secure payment processing</li>
        <li style={S.li}><strong>Google Meet</strong> — for online consultations</li>
        <li style={S.li}><strong>MongoDB Atlas</strong> — for secure cloud data storage</li>
      </ul>

      <h2 style={S.h2}>4. Data Storage &amp; Security</h2>
      <p style={S.p}>Your data is stored securely on encrypted servers. Health records and photos are accessible only to you and your treating doctor. We do not sell your personal data to any third party.</p>

      <h2 style={S.h2}>5. Your Rights</h2>
      <ul style={S.ul}>
        <li style={S.li}>Request a copy of your data</li>
        <li style={S.li}>Request deletion of your account and data</li>
        <li style={S.li}>Opt out of WhatsApp reminders at any time</li>
      </ul>

      <h2 style={S.h2}>6. Contact</h2>
      <p style={S.p}>For any privacy concerns, email us at <strong>support@revivehc.com</strong> or contact us via the <a href="/contact" style={{ color: '#2d6a4f' }}>Contact page</a>.</p>
    </div>
  )
}
